import { Navigate } from 'react-router-dom';
import { hasFeature } from '../helpers/features';

const FeatureGuard = ({ feature, children }) => {
  if (!hasFeature(feature)) {
    return <Navigate to="/ThreatFeed" replace />;
  }
  return children;
};

export default FeatureGuard;
